export interface RubricsLevels {
  range: RubricsRange;
}
export interface RubricsRange {
  name?: string;
  min: number;
  max: number;
}
export interface RubricsAnswersModel {
  totalQuestions: number;
  correctQuestions: number;
  tries: number;
  levels: RubricsRange[];
}
